import { YourAppsListSnippet } from '~/pages/Authenticated/v2/Home/components/Widget/YourApps/Snippets/ListSnippet';

export const YourAppsSnippets = {
  List: YourAppsListSnippet,
};
